import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
export function FinalCta() {
  return <section className="w-full bg-brand-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-116" data-mp="vhivm2qc9gay">
      <div className="mx-auto max-w-2xl text-center" data-id="element-117" data-mp="19ga5te22yhtt">
        <h2 className="font-display text-[26px] font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-118" data-mp="15cuacl1qynip">
          Ogni visita è un’opportunità per prendere una decisione migliore
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-[15px] font-medium leading-relaxed text-white/75 sm:text-lg" data-id="element-119" data-mp="1eettbiwbo1oa">
          La differenza tra cercare continuamente informazioni e avere un processo organizzato può
          essere semplicemente avere gli strumenti giusti a portata di mano.
        </p>

        <div className="mt-8 rounded-3xl border border-white/15 bg-white/5 p-6 sm:p-8" data-id="element-120" data-mp="222uxkfmgwvxw">
          <p className="text-[12px] font-extrabold uppercase leading-snug tracking-[0.14em] text-white/70" data-id="element-121" data-mp="1x51pti5intvi">
            Kit Clinico per la Gestione dell’Obesità
          </p>
          <p className="mt-2 font-display text-[56px] font-extrabold leading-none text-gold sm:text-7xl" data-id="element-122" data-mp="s4pchpyy2gbf">
            €19
          </p>
          <p className="mt-2 text-[13px] font-semibold text-white/70" data-id="element-123" data-mp="x3iotf2hw1a0">
            Cambio di valuta automatico secondo il tuo Paese
          </p>

          <div className="mt-6" data-id="element-124" data-mp="120se8upvwcxu">
            <CtaButton label="Voglio il Kit Clinico ora" note="" data-id="element-125" data-mp="16504iwbzq0y6" />
            <p className="mx-auto mt-3 max-w-md text-[13px] font-medium leading-snug text-white/70" data-id="element-126" data-mp="1b31pxnww2cct">
              Download immediato · Pagamento unico · Accesso a vita · Garanzia di 7 giorni
            </p>
          </div>

          <div className="mt-7" data-id="element-127" data-mp="1ks1oj67hb5qh">
            <Countdown tone="dark" data-id="element-128" data-mp="1kvfu0nbfvv25" />
          </div>

          <div className="mt-6" data-id="element-129" data-mp="1pth9yzdkje9e">
            <ScarcityBar tone="dark" data-id="element-130" data-mp="1puaio5w38du6" />
          </div>
        </div>
      </div>
    </section>;
}